import React from "react";
import styles from "../../pages/styles";
import { kidpointing } from "../../assets/images";

const TechRequiredClasses = () => {
  return (
    <div className="w-full bg-darkprimary pt-8 md:pt-10 px-4 md:px-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8 md:gap-12 items-center">
        <div className="flex-1 flex justify-center md:justify-start items-end md:order-first order-last">
          <img src={kidpointing} alt="Kid Pointing" className="w-full max-w-[320px] md:max-w-[340px]"/>
        </div>
        <div className="flex-1 bg-white p-6 md:p-8 rounded-2xl shadow-lg">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
            What's Needed for Virtual Class Setup
          </h2>
          <ul className="space-y-3">
            <li className="flex items-start">
              <span className="text-orangeprimary mr-2 mt-1">✓</span>
              <span className={`${styles.paragraph} text-sm`}>
                Internet Speed: At least 10 Mbps upload and download
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-orangeprimary mr-2 mt-1">✓</span>
              <span className={`${styles.paragraph} text-sm`}>
                Mouse: A 2 or 3-button mouse with scroll wheel (suggested)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-orangeprimary mr-2 mt-1">✓</span>
              <span className={`${styles.paragraph} text-sm`}>
                Audio: Microphone and speakers, or headset with mic. Optional camera
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-orangeprimary mr-2 mt-1">✓</span>
              <span className={`${styles.paragraph} text-sm`}>
                Storage: At least 3 GB free space (10 GB for advanced classes)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-orangeprimary mr-2 mt-1">✓</span>
              <span className={`${styles.paragraph} text-sm`}>
                Device: Chromebook, PC, or Mac with minimum 8 GB RAM
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TechRequiredClasses;
